import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import NotificationServices from '../../services/NotificationServices';
function AddNotification() {

  const navigate = useNavigate();
  const [formValues, setFormValues] = useState({
    category: '',
    title: '',
    message: '',
    image: '',
  });

  const [previewImage, setPreviewImage] = useState('img/placeholder-img.png');



  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value
    });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
      setFormValues({
        ...formValues,
        image: file,
      });
    }
  };


  

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const formData = new FormData();
      for (const key in formValues) {
        formData.append(key, formValues[key]);
      }
  
      console.log("Form Data Sent:", Object.fromEntries(formData.entries())); 
  
      const response = await NotificationServices.createNotification(formData);
      alert('Notification Added Successfully');
      navigate('/notification');
    } catch (error) {
      console.error('Failed to add Notification details', error);
      alert('Failed to add Notification details');
    }
  };
  

  return (
    <>
      <div className="right_col" role="main">
        <div className="title-box">
          <h2>Notification Add</h2>
          <div className="container-box-top-header-right">
            <Link className="list-banner-btn" to="/notification">Notification List</Link>
          </div>
        </div>
        <div className="container-box px-5">
          <div className="container-box-inner table-reponsive-tabe">
            <div className="page-details">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-lg-12 col-md-12">
                    <div className="input-field customwidth">
                      <label>Select Category<span className="red">*</span></label>
                      <select name="category" value={formValues.category} onChange={handleInputChange} className="full-width">
                        <option value="" disabled>Select Category</option>
                        <option value="All">All</option>
                        <option value="Customer">Customer</option>
                        <option value="Vendor">Vendor</option>
                      </select>

                    </div>
                  </div>

                  <div className="col-lg-12 col-md-6">
                    <div className="input-field">
                      <label>Tittle<span className="red">*</span></label>
                      <input type="text" name="title" className="form-control" value={formValues.title}
                        onChange={handleInputChange} placeholder="New notification"  />
                    </div>
                  </div>


                  <div className="col-sm-12">
                    <div className="input-field">
                      <label>Description<span className="red">*</span></label>
                      <textarea className="form-control video-desc" name="message" value={formValues.message}
                        onChange={handleInputChange} placeholder='New description'  />
                    </div>
                  </div>
                  <div className="col-sm-12">
                    <div className="input-field">
                      <label>Upload<span className="red">*</span></label>
                      <input type="file" name="image" className="form-control"  onChange={handleFileChange} />
                      <p><span>Drop an image or Paste URL (upto resolution 1,500 x 1,500 px),</span> Supported formats: png, jpeg, jpg, webp</p>
                      <div className="file-preview text-center">
                        <img id="uploadFile" src={previewImage} alt="your image" />
                      </div>
                    </div>
                  </div>
                </div>
                <button className="submit-green-btn">Send Notification</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AddNotification